import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@material-ui/core";
import { Auth } from "aws-amplify";
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styles from "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  AttachmentButton,
  SendButton,
  InputToolbox,
  TypingIndicator,
} from "@chatscope/chat-ui-kit-react";
import { useState } from "react";
import AWS from "aws-sdk";
import Swal from "sweetalert2";
export default function PerformanceFeedback({ title, link }) {
  const [csvFile, setCsvFile] = useState(null);
  const [csvload, setcsvload] = useState(false);
  const [trainload, setTrainload] = useState(false);
  const [answerload, setAnswerload] = useState(false);
  const [displayText, setDisplayText] = useState("");
  // const [question, setQuestion] = useState("");
  const [output, setOutput] = useState("");
  const [error, setError] = useState("");
  const [deleteError, setdeleteError] = useState("");
  const [selectedModel, setSelectedModel] = useState("meta.llama2-13b-chat-v1");
  const [modeltext, setModelText] = useState("LLAMA 13b");
  const timetaken = useRef(0);
  const [initialContentDisplayed, setInitialContentDisplayed] = useState(true);
  const [feedbackResponses, setFeedbackResponses] = useState([]);

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const [messages, setMessages] = useState([]);
  const [genaiaccess, setgenaiaccess] = useState(false);
  const [isInputDisabled, setIsInputDisabled] = useState(false);
  const [transcript, setTranScript] = useState("");

  useEffect(() => {
    if (transcript.length > 0) {
      // console.log("Original Transcript: ", transcript);
      const formattedTranscript = formatResponse(transcript);
      // console.log("Formatted Response: ", formattedTranscript);
      let index = 0;
      const intervalId = setInterval(() => {
        setDisplayText((prev) => prev + formattedTranscript[index]);
        index++;
        if (index === formattedTranscript.length) {
          clearInterval(intervalId);
          setTranScript("");
        }
      }, 1);
    }
  }, [transcript]);

  const formatResponse = (response) => {
    // Replacing markdown-like headers with HTML headers
    const headers = response
      .replace(/(######\s?)(.*?)\n/g, "<h6>$2</h6>")
      .replace(/(#####\s?)(.*?)\n/g, "<h5>$2</h5>")
      .replace(/(####\s?)(.*?)\n/g, "<h4>$2</h4>")
      .replace(/(###\s?)(.*?)\n/g, "<h3>$2</h3>")
      .replace(/(##\s?)(.*?)\n/g, "<h2>$2</h2>")
      .replace(/(#\s?)(.*?)\n/g, "<h1>$2</h1>");

    // Splitting and replacing bold markers
    let responseArray = headers.split("**");
    let newResponse = "";
    for (let i = 0; i < responseArray.length; i++) {
      if (i % 2 === 0) {
        newResponse += responseArray[i];
      } else {
        newResponse += "<b>" + responseArray[i] + "</b>";
      }
    }

    // Replace asterisks and newlines for proper HTML formatting
    newResponse = newResponse.replace(/\*/g, "<br/>");
    newResponse = newResponse.replace(/\n/g, "<br/>");
    newResponse = newResponse.replace(/\\"/g, '"');

    return newResponse;
  };

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  const handleSendMessage = (messageText) => {
    // Create a new message object
    const newMessage = {
      id: Math.random().toString(), // Generate a unique ID for the message
      text: "Manager: " + messageText,
      sender: "User",
      direction: "outgoing",
    };
    // Update the messages state by adding the new message
    setInitialContentDisplayed(false);
    setMessages((prevMessages) => [...prevMessages, newMessage]);
    handleQuestion1(messageText);
  };

  const handleQuestion = async (question) => {
    if (question.length > 0) {
      timetaken.current = 0;
      let time = setInterval(() => {
        timetaken.current = parseFloat(timetaken.current) + 0.1;
      }, 100);
      setAnswerload(true);
      console.log("reqeusting");
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      var data = JSON.stringify({
        model: selectedModel,
        question: question,
        docpath: username,
      });

      var xhr = new XMLHttpRequest();
      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
          setOutput(JSON.parse(this.responseText));
          console.log(JSON.parse(this.responseText));
          setAnswerload(false);
          // selectedModel == "ai21.j2-ultra-v1"
          // ? "Jurassic-2 Ultra\n"
          // : selectedModel == "meta.llama2-13b-chat-v1"
          // ? "LLama 13B\n"
          // : selectedModel == "anthropic.claude-haiku-4-5-20251001-v1:0" &&
          //   "Claude Haiku\n"
          const newMessage = {
            id: Math.random().toString(), // Generate a unique ID for the message errorMessage
            text: JSON.parse(this.responseText)["messsage"]
              ? "Response by " +
                modeltext +
                "\n\n" +
                JSON.parse(this.responseText)["messsage"] +
                "\n\nTime taken: " +
                timetaken.current.toFixed(2) +
                " sec"
              : JSON.parse(this.responseText)["errorMessage"] &&
                "Response by " +
                  modeltext +
                  "\n" +
                  "Something went wrong" +
                  "\n\nTime taken: " +
                  timetaken.current.toFixed(2) +
                  " sec",
            sender: "Chatbot",
            direction: "incoming",
          };
          clearInterval(time);
          // Update the messages state by adding the new message
          setMessages((prevMessages) => [...prevMessages, newMessage]);
        }
      });

      xhr.open(
        "POST",
        // "https://ixies944jb.execute-api.ap-south-1.amazonaws.com/dev/getanswer"
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/custom-chatbot-response",
      );
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);
    } else {
      setError("please enter question");
    }
  };

  const handleQuestion1 = async (question) => {
    setTranScript("");
    setDisplayText("");
    if (question.length > 0) {
      timetaken.current = 0;

      // Start the timer to track time taken for the request
      let time = setInterval(() => {
        timetaken.current = parseFloat(timetaken.current) + 0.1;
      }, 100);

      setAnswerload(true);
      console.log("requesting");

      // Get the username and prepare the payload object
      const username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );

      // Collect the entire conversation history
      const conversation_list = Array.isArray(messages)
        ? messages.map((message) => message.text)
        : [];

      // Prepare payload as done in the handleCompare function
      const payload = {
        conversation_list: conversation_list,
        managers_feedback: question,
      };

      console.log("Payload before sending:", payload);

      try {
        // Use fetch instead of XMLHttpRequest
        const response = await fetch(
          "https://q5td7r6nbzj7bjj633pab65wvy0dever.lambda-url.ap-south-1.on.aws/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          },
        );

        // Parse the response
        const data = await response.json();
        console.log("Response Data:", data);

        // Set the output and stop loading spinner
        setOutput(data);
        setAnswerload(false);

        // Extract message and conclusion from the response
        const chatbotMessage = data.message || "No message available";
        const chatbotConclusion = data.conclusion || "No conclusion available";

        if (data.status === true) {
          setIsInputDisabled(true);
          setTranScript("");
          setDisplayText("");
        }

        // Append the message to the Chatbot messages
        const newMessage = {
          id: Math.random().toString(), // Generate a unique ID for the message
          text: chatbotMessage,
          sender: "Chatbot",
          direction: "incoming",
        };

        clearInterval(time);
        setMessages((prevMessages) => [...prevMessages, newMessage]);
        setTranScript(chatbotConclusion);

        // Add response to feedbackResponses
        setFeedbackResponses((prevFeedback) => [
          ...prevFeedback,
          {
            text: `Feedback ${prevFeedback.length + 1}`,
            conclusion: chatbotConclusion,
            id: Math.random().toString(), // Unique ID for each feedback
          },
        ]);
      } catch (error) {
        console.error("Error occurred during the request:", error);
        setAnswerload(false);

        // Handle any errors that occur during the fetch call
        const newMessage = {
          id: Math.random().toString(),
          text: "Something went wrong",
          sender: "Chatbot",
          direction: "incoming",
        };
        setMessages((prevMessages) => [...prevMessages, newMessage]);
        clearInterval(time);
      }
    } else {
      setError("please enter question");
    }
  };

  const handleStart = async () => {
    setMessages("");
    setTranScript("");
    setDisplayText("");
    setInitialContentDisplayed(true);
  };

  const defaultContent = `<strong>Welcome Manager!</strong> This chat is designed to help you simulate a scenario for training purposes. You’ll be practicing how to give feedback to a team member regarding their performance over the last quarter. Please go ahead and provide the feedback.
  <br>You will be tested on the following communication tenets: <br><strong>1. Clarity:</strong> Was your feedback clear and easy to understand?<br><strong>2. Specificity:</strong> Was the feedback specific and crisp?<br><strong>3. Constructiveness:</strong> Did you offer actionable steps for improvement?<br><strong>4. Balance Positive and Negative Feedback:</strong> Did you balance positive feedback with areas for growth?<br><strong>5. Empathetic and Openness:</strong> Did you invite input and create a two-way dialogue?<br><strong>6. Tone:</strong> Was your tone professional and respectful?<br><strong>7. Follow Up:</strong> Did you suggest a plan for follow-up to track progress?<br><strong>8. Focus on the Future:</strong> Did you suggest highlighting how improvements can be made going forward?
  `;

  const handleFeedbackClick = (response) => {
    setDisplayText(formatResponse(response.conclusion)); // Show the full conclusion in the feedback window
  };

  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {title}
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                    <Button  variant="contained" color="primary" >Home</Button>
                                </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div
          className="emailsum-container"
          style={{
            alignContent: "start",
            gap: "2rem",
            width: "95vw",
            fontFamily: "'Outfit', sans-serif",
          }}
        >
          <div
            className="result-chatbot"
            style={{ flex: "4", alignContent: "start", padding: "2rem 1.5rem" }}
          >
            {/* <h4>Chatbot</h4> */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "0.5rem",
                fontFamily: "'Outfit', sans-serif",
              }}
            >
              <h3>
                <strong>Chat Window</strong>
              </h3>
              <Button variant="contained" color="primary" onClick={handleStart}>
                New Chat
              </Button>
            </div>
            <div
              style={{
                position: "relative",
                height: "500px",
                fontFamily: "'Outfit', sans-serif",
              }}
            >
              <MainContainer
                style={{
                  borderRadius: "1rem",
                  backgroundColor: "#F0F0F0",
                  color: "#333333",
                  fontFamily: "'Outfit', sans-serif",
                }}
              >
                <ChatContainer
                  style={{
                    padding: "0.5rem",
                    fontFamily: "'Outfit', sans-serif",
                    backgroundColor: "#F0F0F0",
                    fontSize: "1.05rem",
                  }}
                >
                  <MessageList
                    style={{
                      backgroundColor: "#F0F0F0",
                      color: "#333333",
                      fontFamily: "'Outfit', sans-serif",
                    }}
                    typingIndicator={
                      answerload && (
                        <TypingIndicator content="chatbot is typing" />
                      )
                    }
                    autoScrollToBottomOnMount={true}
                  >
                    {Array.isArray(messages) &&
                      messages.map((message, index) => (
                        // <Message
                        //   key={index}
                        //   model={{
                        //     message: message.text,
                        //     direction: message.direction,
                        //   }}
                        // />
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "1rem",
                            justifyContent:
                              message.direction === "outgoing"
                                ? "flex-end"
                                : "flex-start",
                          }}
                        >
                          {message.direction === "incoming" && (
                            <>
                              <img
                                src="/assets/images/team-member.png"
                                alt="Chatbot Icon"
                                style={{
                                  marginRight: "0.5rem",
                                  width: "36px",
                                  height: "36px",
                                  borderRadius: "50%",
                                }}
                              />
                              <div
                                style={{
                                  fontFamily: "'Outfit', sans-serif",
                                  fontSize: "1rem",
                                  backgroundColor: "#E0E0E0",
                                  padding: "0.75rem",
                                  borderRadius: "10px",
                                  maxWidth: "91%",
                                  wordWrap: "break-word",
                                }}
                              >
                                <CharacterByCharacter message={message.text} />
                              </div>
                            </>
                          )}

                          {message.direction === "outgoing" && (
                            <>
                              <div
                                style={{
                                  fontFamily: "'Outfit', sans-serif",
                                  fontSize: "1rem",
                                  backgroundColor: "#DCF8C6",
                                  padding: "0.75rem",
                                  borderRadius: "10px",
                                  maxWidth: "70%",
                                  wordWrap: "break-word",
                                  textAlign: "right",
                                  color: "#333333",
                                  marginRight: "0.5rem",
                                }}
                              >
                                {message.text}
                              </div>
                              <img
                                src="/assets/images/manager.png"
                                alt="User Icon"
                                style={{
                                  marginLeft: "0.5rem",
                                  width: "36px",
                                  height: "36px",
                                  borderRadius: "50%",
                                }}
                              />
                            </>
                          )}
                        </div>
                      ))}
                  </MessageList>
                  <MessageInput
                    attachButton={false}
                    placeholder="Type message here"
                    onSend={handleSendMessage}
                    disabled={isInputDisabled || transcript.length > 0}
                    style={{
                      fontFamily: "'Outfit', sans-serif",
                      borderRadius: "1rem",
                    }}
                  />
                  {/* <InputToolbox>
                        <AttachmentButton />
                        <SendButton />
                      </InputToolbox> */}
                </ChatContainer>
              </MainContainer>
            </div>
          </div>
          <div
            className="input-form-chatbot"
            style={{
              flex: "2.5",
              margin: "0",
              maxHeight: "700px",
              overflowY: "auto",
              padding: "2rem 3rem",
              fontFamily: "'Outfit', sans-serif",
            }}
          >
            <h3>
              <strong>Feedback Window</strong>
            </h3>
            <div
              className="section-container"
              style={{
                fontFamily: "'Outfit', sans-serif",
                color: "#333333",
                backgroundColor: "#F0F0F0",
              }}
            >
              <h4>
                <strong>Latest Response Feedback</strong>
              </h4>
              <hr style={{ background: "#333333" }}></hr>
              {/* Feedback Buttons */}
              <div
                style={{
                  marginBottom: "1rem",
                  display: "flex",
                  flexWrap: "wrap", // Allow buttons to wrap to the next line
                  gap: "10px", // Optional: Add spacing between buttons
                }}
              >
                {feedbackResponses.map((response, index) => (
                  <Button
                    key={response.id}
                    variant="contained"
                    color="primary"
                    onClick={() => handleFeedbackClick(response)} // Display full feedback on click
                    // style={{
                    //   flex: "1 1 calc(33.33% - 10px)", // Ensure 3 buttons per row with space between
                    //   textTransform: "none",
                    //   marginBottom: "10px", // Spacing between rows
                    // }}
                    style={{
                      flex: "1 1 calc(33.33% - 10px)",
                      textTransform: "none",
                      marginBottom: "10px",
                      width: "100%",
                      minWidth: "120px",
                      maxWidth: "200px",
                      padding: "10px 20px",
                      boxSizing: "border-box",
                    }}
                  >
                    {response.text} {/* Shows Feedback 1, Feedback 2, etc. */}
                  </Button>
                ))}
              </div>

              {initialContentDisplayed ? (
                <div
                  style={{
                    color: "#333333",
                    fontFamily: "'Outfit', sans-serif",
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                  dangerouslySetInnerHTML={{ __html: defaultContent }}
                ></div>
              ) : displayText.length > 0 ? (
                <div
                  style={{
                    color: "#333333",
                    fontFamily: "'Outfit', sans-serif",
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                  dangerouslySetInnerHTML={{ __html: displayText }}
                ></div>
              ) : (
                "Response will be displayed here"
              )}
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}

const CharacterByCharacter = ({ message }) => {
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    let currentIndex = 0;
    const intervalId = setInterval(() => {
      setDisplayedText((prev) => prev + message[currentIndex]);
      currentIndex += 1;
      if (currentIndex === message.length) {
        clearInterval(intervalId); // Stop once the full message is displayed
      }
    }, 25); // Adjust the interval time (in ms) to control typing speed

    return () => clearInterval(intervalId); // Clean up interval on component unmount
  }, [message]);

  return <span>{displayedText}</span>;
};
